import React from 'react';

import { DeleteIcon } from '@sharedCR/coreDesignSystem/icons';
import ButtonWithTooltip from 'app/shared/components/common/ButtonWithTooltip';
import dayjs from 'dayjs';

import { COMMON_DATETIME_FORMAT } from 'constants/date';

import { UnderwritingTestIds } from '../../../../Underwriting.testIds';

const baseColumns = [
  {
    id: 'signerFullName',
    align: 'left',
    disablePadding: false,
    label: 'Recipient Name',
  },
  {
    id: 'status',
    align: 'left',
    disablePadding: false,
    label: 'Delivery Status',
  },
  {
    id: 'generatedDate',
    align: 'left',
    disablePadding: false,
    label: 'Generated',
    tooltip: 'The disclosures will be generated',
    format: ({ value }) => (value ? `${dayjs(value).format(COMMON_DATETIME_FORMAT)}` : 'N/A'),
  },
  {
    id: 'sentDate',
    align: 'left',
    disablePadding: false,
    label: 'Sent',
    tooltip: 'The disclosures were emailed to the borrower',
    format: () => 'N/A',
  },
  {
    id: 'openedDate',
    align: 'left',
    disablePadding: false,
    label: 'Opened',
    tooltip: 'The borrower opened the email',
    format: () => 'N/A',
  },
  {
    id: 'consentedDate',
    align: 'left',
    disablePadding: false,
    label: 'Read',
    tooltip: 'The borrower viewed the document',
    format: () => 'N/A',
  },
  {
    id: 'signedDate',
    align: 'left',
    disablePadding: false,
    label: 'E-Signed',
    tooltip: 'The borrower signed the documents',
    format: () => 'N/A',
  },
];

const cancelColumn = {
  id: 'cancel',
  align: 'left',
  disablePadding: false,
  label: '',
  minWidthClassName: 'min-w-60',
  format: ({ onCancelButtonClick }) => (
    <ButtonWithTooltip
      data-testid={UnderwritingTestIds.SCHEDULED_BUNDLE_HISTORY_CANCEL_BUTTON}
      icon={DeleteIcon}
      title="Cancel sending bundle"
      onClick={onCancelButtonClick}
    />
  ),
};

export const getColumns = ({ enableCancel }) =>
  enableCancel ? [...baseColumns, cancelColumn] : baseColumns;
